import { Injectable } from "@angular/core";

export enum EnumCheckCredentialsResult
{
    Success = "Success",
    Failure = "Failure",
    Lockout = "Lockout",
    PasswordExpired = "PasswordExpired",
    SessionExpired = "SessionExpired",
    NoLicense = "NoLicense",
    TechnicalFailure = "TechnicalFailure",
    MFASMSSent = "MFASMSSent",
    MFAEmailSent = "MFAEmailSent",
    NoMID="NoMID"
}
export enum EnumPageDisplayModes
{
    FullScreen = "FullScreen",
    Window = "Window",
    Dialog = "Dialog",
    BottomSheet = "BottomSheet"
}

export enum EnumPageEntitySources
{
    Internal = "Internal",
    External = "External",
    CRUD = "CRUD"
}

export enum EnumScreenSizes
{
    ScreenXSmall = "ScreenXSmall",
    ScreenSmall = "ScreenSmall",
    ScreenMedium = "ScreenMedium",
    ScreenLarge = "ScreenLarge",
    ScreenXLarge = "ScreenXLarge"
}

export enum EnumWindowSizes
{
    WindowXSmall = "WindowXSmall",
    WindowSmall = "WindowSmall",
    WindowMedium = "WindowMedium",
    WindowLarge = "WindowLarge",
    WindowXLarge = "WindowXLarge",
    WindowAutoSize = "WindowAutoSize"
}

export enum EnumCRUDActions
{
    Create = "Create",
    Update = "Update",
    CreateOrUpdate = "CreateOrUpdate",
    Delete = "Delete"
}

export enum EnumRequestProgressTracking
{
    Send = "Send",
    Receive = "Receive",
    Both = "Both"
}


export enum EnumToggle
{
    In = 'In',
    Out = 'Out'
}

export enum EnumCardMode 
{
    Simple = 'Simple',
    Expand = 'Expand',
    SimpleExpand = 'SimpleExpand',
    Edit = 'Edit'
}

export enum EnumGridModes
{
    Editable = 'Editable',
    Report = 'Report',
    Lines = 'Lines'
}

export enum EnumGridScrollingModes
{
    Virtual = "virtual",
    Standart = "standart",
    Infinite = "infinite"
}

export enum EnumInputBoxTypes
{
    Text = "Text",
    TextArea = "TextArea",
    Number = "Number",
    Date = "Date"
}

export enum EnumMessageBoxTypes
{
    OK = "OK",
    YesNo = "YesNo",
    Custom = "Custom"
}

export enum EnumFileBoxReturnDataTypes
{
    FileList = "FileList",
    FileDataAsString = "FileStringData",
    FileDataAsLinesArray = "FileDataAsLinesArray",
    FileDataAsJSONArray = "FileDataAsJSONArray"
}

export enum EnumNotificationDeliveryOptions
{
    Email = "Email",
    Phone = "Phone",
    PushMessage = "PushMessage",
    Print = "Print",
    ExportToPDF = "ExportToPDF",
    WhatsApp = "WhatsApp"
} 

export enum EnumLoginExtensionLinkType
{
    Link,
    Route,
    Mailto,
    ButtonLink
}

export enum EnumApplicationMode
{
    Standard = "Standard",
    IFrame = "IFrame",
    SinglePage = "SinglePage"
}

export enum EnumLanguages
{
    Hebrew = "HE",
    English = "EN"
}

export enum EnumNotificationStatuses
{
    Draft = "Draft",
    Sending = "Sending",
    Failure = "Failure",
    Sent = "Sent"
}

export enum EnumPopupShowStatuses
{
    None = "None",
    ToShow = "ToShow",
    Showed = "Showed"
}

export enum EnumFilterPanelActions
{
    Apply = "Apply",
    Clear = "Clear",
    Ready = "Ready"
}

export enum EnumSidebarActions
{
    Open = "Open",
    Close = "Close",
    Toggle = "Toggle"
}

export enum EnumSidebarStates
{
    Opened = "Opened",
    Closed = "Closed"
}

export enum EnumMenuPositions
{
    Open = "Open",
    Close = "Close"
}

export enum EnumMFAMethods
{
    None = "None",
    SMS = "SMS",
    Email = "Email"
}

export enum EnumLoginSecureKeyTypes{
    Password = "Password",
    Otp = "Otp",
    MFACode = "MFACode",
    Session = "Session"
}

export enum EnumInfoUTypes {
    Unicell = "Unicell",
    InforU = "InforU"
}

export enum EnumSystemOptionDataTypes {
    String = "String",
    Number = "Number",
    Boolean = "Boolean"
}

export enum EnumSystemOptions {
    AppNameHE = 'AppNameHE',
    AppNameEN = 'AppNameEN',
    AppURL = 'AppURL',

    SessionTimeout = 'SessionTimeout',
    SessionExpiry = 'SessionExpiry',
    EnableRequestLogging = 'EnableRequestLogging',
    EnableRemoteLogging = 'EnableRemoteLogging',
    ShowExpiredTimeoutAlert = 'ShowExpiredTimeoutAlert',
    ShowAlmostExpiredTimeoutAlert = 'ShowAlmostExpiredTimeoutAlert',

    IsSupportedCredentialsManagement = 'IsSupportedCredentialsManagement',
    IsSupportedUserWelcome = 'IsSupportedUserWelcome',
    IsSupportedPasswordChange = 'IsSupportedPasswordChange',
    IsSupportedPasswordRecovery = 'IsSupportedPasswordRecovery',
    IsSupportedLoginByOTP = 'IsSupportedLoginByOTP',
    IsSupportedLoginByPassword = 'IsSupportedLoginByPassword',
    IsAutoCreateCredentials = 'IsAutoCreateCredentials',
    AutoCreateCredentialsType = 'AutoCreateCredentialsType',
    IsRequireTaxNumberForOTP = 'IsRequireTaxNumberForOTP',

    PasswordChangeIntervalDays = 'PasswordChangeIntervalDays',
    PasswordComplexityLen = 'PasswordComplexityLen',
    PasswordComplexityMinChars = 'PasswordComplexityMinChars',
    PasswordComplexityMinDigits = 'PasswordComplexityMinDigits',

    BadLoginAttemptBeforeLock = 'BadLoginAttemptBeforeLock',
    BadLoginAttemptsCheckIntervalMinutes = 'BadLoginAttemptsCheckIntervalMinutes',
    BadLoginAttemptLockouIntervalMinutes = 'BadLoginAttemptLockouIntervalMinutes',

    XFrameOptions = 'XFrameOptions',
    IsDeployedBehindLoadBalancer = 'IsDeployedBehindLoadBalancer'
}

export enum HistoryEventTypesEnum {
    FieldChange = "FieldChange",
    RowAdded = "RowAdded",
    RowDeleted = "RowDeleted",
    Special = "Special"
}

export enum EnumPrintingType {
    Entity = "Entity",
    Report = "Report"
}

export enum EnumUserLoginStatus {
    All = "All",
    Success = "Success",
    Failure = "Failure"
}

@Injectable()
export class SysEnumsService 
{
    constructor() {}

    public EnumWindowSizes = EnumWindowSizes;
    public EnumCardMode = EnumCardMode;
    public EnumToggle = EnumToggle;
    public EnumInputBoxTypes = EnumInputBoxTypes;
    public EnumMessageBoxTypes = EnumMessageBoxTypes;
    public EnumFileBoxReturnDataTypes = EnumFileBoxReturnDataTypes;
    public EnumNotificationDeliveryOptions = EnumNotificationDeliveryOptions;
    public EnumLoginExtensionLinkType = EnumLoginExtensionLinkType;
    public EnumApplicationMode = EnumApplicationMode;
    public EnumNotificationStatuses = EnumNotificationStatuses;
    public EnumPageDisplayModes = EnumPageDisplayModes;
    public EnumLanguages = EnumLanguages;
    public EnumFilterPanelActions = EnumFilterPanelActions;
    public EnumMenuPositions = EnumMenuPositions;
    public EnumMFAMethods = EnumMFAMethods;
    public EnumSidebarActions = EnumSidebarActions;
    public EnumSystemOptionDataTypes = EnumSystemOptionDataTypes;
    public HistoryEventTypesEnum = HistoryEventTypesEnum;
    public EnumPrintingType = EnumPrintingType;
    public EnumInfoUTypes = EnumInfoUTypes;
    public EnumUserLoginStatus = EnumUserLoginStatus;
}
